export default {
  toolbar: (state) => state.toolbar,
};
